import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Cookies from 'js-cookie'
import BaiduMap from 'vue-baidu-map'
import config from '../config'
import VueCookie from 'vue-cookie'
import 'video.js/dist/video-js.css';
import {InfiniteScroll} from "element-ui";
import wxUtil from './utils/WxUtil'
import TlbsMap from 'tlbs-map-vue';


// import VConsole from 'vconsole';
// const vConsole = new VConsole();

Vue.use(Element, {
  size: Cookies.get('size') || 'medium'
})
Vue.use(BaiduMap, {
  ak: 'DeNOFoYTiTHlaMGFW5XnvfknM0SWf1HG'
})
Vue.use(TlbsMap);
Vue.use(VueCookie)
Vue.use(InfiniteScroll);

Vue.config.productionTip = false
Vue.prototype.$config = config

function getURLParameter(name) {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}

// 小程序 浏览器使用
window.miniprogram = false;
// 甘快办使用
window.isMiniProgram = !getURLParameter('clientId')
window.position = getURLParameter('location');
wxUtil.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
